














import Vue from 'vue';
import { IPartnerShopImages } from '@/common/interfaces/partnershop.interface';
import config from '../../../config';

interface IPartnerShopNotification {
  partnerShopImages: IPartnerShopImages;
}

export default Vue.extend({
  name: `PartnershopNotification`,
  data(): IPartnerShopNotification {
    return {
      partnerShopImages: config.partnershop.images,
    };
  },
});
